import axios from "axios";
import URL from "../../helpers/URL";
import configuration from "./configuration";


export const updateUserProfile = (data:any) => {
    const config = configuration()
    return axios.patch(URL.updatePatient, data, config)
}

export const getUserProfile = () => {
    const config = configuration()
    return axios.get(URL.getUserProfile, config)
}

export const changeProfileImage = (data:any, additionalConfig:any) => {
    const config = {...additionalConfig,...configuration()}
    return axios.patch(URL.changeProfileImage, data, config)
}